//* 动画库
import { gsap } from "gsap";

interface AnimationOptions {
    beforeEnter?: () => void;
    beforeLeave?: () => void;
    afterEnter?: () => void;
    afterLeave?: () => void;
}

//* 动画（选择器）
export const selector = (is: boolean, dones?: AnimationOptions) => {
    return {
        //* 动画（离场前）
        "before-leave": () => dones?.beforeLeave?.(),
        //* 动画（入场前）
        "before-enter": (el: Element) => (dones?.beforeEnter?.(), is && gsap.set(el, { opacity: 0, height: 0 })),
        //* 动画（离场）
        "leave": (el: Element, done: () => void) => {
            //* 动画脚本
            if (!is) dones?.afterLeave?.(), done?.();
            else {
                gsap.to(el, {
                    height: 0,
                    opacity: 0,
                    duration: 0.2,
                    onComplete: () => (dones?.afterLeave?.(), done?.()),
                });
            }
        },
        //* 动画（入场）
        "enter": (el: Element, done: () => void) => {
            //* 动画脚本
            if (!is) dones?.afterEnter?.(), done?.();
            else {
                gsap.to(el, {
                    height: "auto",
                    opacity: 1,
                    duration: 0.2,
                    onComplete: () => (dones?.afterEnter?.(), done?.()),
                });
            }
        },
    };
};

export const tooltip = (dones?: AnimationOptions) => {
    return {
        //* 动画（离场前）
        "before-leave": () => dones?.beforeLeave?.(),
        //* 动画（入场前）
        "before-enter": (el: Element) => (dones?.beforeEnter?.(), gsap.set(el, { opacity: 0 })),
        //* 动画（离场）
        "leave": (el: Element, done: () => void) => {
            gsap.to(el, {
                opacity: 0,
                duration: 0.2,
                onComplete: () => (dones?.afterLeave?.(), done?.()),
            });
        },
        //* 动画（入场）
        "enter": (el: Element, done: () => void) => {
            gsap.to(el, {
                opacity: 1,
                duration: 0.2,
                onComplete: () => (dones?.afterEnter?.(), done?.()),
            });
        },
    };
};
